module.exports = __webpack_public_path__ + "img/IMÁGENES CLÍNICAS KU1 1.7a81d9c6.png";